export function setUserDetails(payload) {
    return { type: 'SET_USER_DETAILS', payload: payload }
}